import { motion } from "framer-motion";

const fases = [
  {
    numero: "Fase 1",
    titulo: "Fundación de Autoridad",
    descripcion:
      "Identidad, posición, arquitectura, mensajes, liderazgo visible y definición del equipo 360. 90 días.",
    precio: "USD 21.000 · 18.000 pago único",
    destacada: true,
  },
  {
    numero: "Fase 2",
    titulo: "Sistema de Expresión",
    descripcion:
      "Identidad visual personal completa, narrativa, kit de speaker y sistema de piezas.",
    precio: "Se cotiza al cierre de Fase 1",
    destacada: false,
  },
  {
    numero: "Fase 3",
    titulo: "Activación 360 y Gobernanza",
    descripcion:
      "Puesta en marcha sostenida con el equipo externo, medición por KPIs y custodia de la coherencia.",
    precio: "Acuerdo mensual",
    destacada: false,
  },
];

const GastonMapa = () => {
  return (
    <section
      className="py-24 md:py-32 relative overflow-hidden"
      style={{
        background:
          "linear-gradient(180deg, hsl(217 61% 8%), hsl(215 48% 14%))",
      }}
    >
      <div className="container px-4 max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-14 max-w-3xl mx-auto"
        >
          <span
            className="text-sm font-semibold tracking-[0.25em] uppercase mb-4 block"
            style={{ color: "#5BA3E0" }}
          >
            El mapa completo
          </span>
          <h2 className="font-display text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.1]">
            Arrancamos por la Fase 1.
            <br />
            <span style={{ color: "#5BA3E0" }}>
              Si el trabajo te convence, seguimos.
            </span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-5 mb-12">
          {fases.map((f, index) => (
            <motion.div
              key={f.numero}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.55, delay: index * 0.12 }}
              className="rounded-2xl p-7 border flex flex-col"
              style={{
                borderColor: f.destacada
                  ? "rgba(91,163,224,0.45)"
                  : "rgba(255,255,255,0.1)",
                background: f.destacada
                  ? "linear-gradient(135deg, hsl(217 61% 12%), hsl(215 48% 18%))"
                  : "hsl(220 69% 4%)",
              }}
            >
              <span
                className="text-xs font-semibold uppercase tracking-[0.22em] mb-3"
                style={{
                  color: f.destacada ? "#5BA3E0" : "rgba(255,255,255,0.45)",
                }}
              >
                {f.numero}
              </span>
              <h3 className="font-display text-xl md:text-2xl font-semibold text-white mb-3 leading-snug">
                {f.titulo}
              </h3>
              <p className="text-sm md:text-base text-white/75 leading-relaxed mb-6">
                {f.descripcion}
              </p>
              <p
                className="mt-auto pt-4 border-t border-white/10 font-semibold text-sm md:text-base"
                style={{ color: f.destacada ? "#4FD1A5" : "rgba(255,255,255,0.6)" }}
              >
                {f.precio}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.35 }}
          className="text-center text-sm md:text-base text-white/70 max-w-3xl mx-auto leading-relaxed"
        >
          No cotizamos Fase 2 hoy, y es deliberado: su alcance depende de
          las decisiones estratégicas que se toman en Fase 1.
          <br />
          Cotizar antes sería inventar un número, y eso no es cómo trabajamos.
        </motion.p>
      </div>
    </section>
  );
};

export default GastonMapa;
